import {
    SEARCH_CUSTOMERS_BY_CODE_REQUEST_FAILED,
    SEARCH_CUSTOMERS_BY_CODE_REQUEST_SUCCESS,
    SEARCH_CUSTOMERS_BY_NAME_REQUEST_FAILED,
    SEARCH_CUSTOMERS_BY_NAME_REQUEST_SUCCESS
} from "./CustomerConstants";

const initialState = {
    customersByCode: [],
    customersByName: [],
    searchError: false
}

const reducer = (state = initialState, action) => {
    switch (action.type) {

        case SEARCH_CUSTOMERS_BY_CODE_REQUEST_SUCCESS:
            return {
                ...state,
                customersByCode: action.payload,
                searchError: false
            }

        case SEARCH_CUSTOMERS_BY_CODE_REQUEST_FAILED:
            return {
                ...state,
                customersByCode: [],
                searchError: true
            }

        case SEARCH_CUSTOMERS_BY_NAME_REQUEST_SUCCESS:
            return {
                ...state,
                customersByName: action.payload,
                searchError: false
            }

        case SEARCH_CUSTOMERS_BY_NAME_REQUEST_FAILED:
            return {
                ...state,
                customersByName: [],
                searchError: true
            }

        default:
            return state

    }
}

export default reducer;
